import React from 'react';
import { Box, IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { launchColors } from '../launchTheme';
import { openAssetInAthena } from './AssetHoverLink';

const AthenaMark: React.FC<{ assetId: string; articleNumber: string }> = ({ assetId, articleNumber }) => (
  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, flexShrink: 0 }}>
    <Box component="span" title="Finns i Athena" sx={{ fontSize: 11, fontWeight: 700, px: 0.75, borderRadius: '8px', lineHeight: '18px', color: launchColors.petrolDark, bgcolor: launchColors.petrolLight, whiteSpace: 'nowrap' }}>
      Athena
    </Box>
    <IconButton
      size="small"
      aria-label={`Öppna ${articleNumber} i Athena`}
      title="Öppna i Athena"
      onClick={(event) => {
        event.stopPropagation();
        openAssetInAthena(assetId);
      }}
      sx={{ p: 0.25 }}
    >
      <OpenInNewIcon sx={{ fontSize: 16 }} />
    </IconButton>
  </Box>
);

export default AthenaMark;
